import { LiveStreamStatus } from 'types/stream';

const getIsPastStream = (state: LiveStreamStatus) => ['FINISHED', 'CANCELED', 'FAILED'].includes(state);

export default getIsPastStream;
